import request from '@/utils/request'
import Store from '@/store'

// 查询赛事类型集合
export function ApiQuerycompetitiontypes(params) {
  return request({
    url: "api/competitions/querycompetitiontypes",
    method: "GET",
    params
  })
}

// 获取赛事
export function ApiGetcompetitionlist() {
  return request({
    url: "api/competitions/getcompetitionlist",
    method: "GET",
    params: {
      competitionChannelId: Store.state.olympicMusicShow.channelId || 0
    }
  })
}

// 查询城市区域集合
export function ApiQueryregions(params) {
  return request({
    url: "api/commons/queryregions",
    method: "GET",
    params
  })
}

// 赛事报名
export function ApiSignupCompetition(data) {
  return request({
    url: "api/competitions/signupcompetition",
    method: "POST",
    data
  })
}

// 查询赛事报名记录集合
export function ApiQuerySignupRecords(params) {
  return request({
    url: "api/competitions/querySignupRecords",
    method: "GET",
    params
  })
}

// 查询赛事报名记录详情
export function ApiGetsignuprecord(params) {
  return request({
    url: "api/competitions/getsignuprecord",
    method: "GET",
    params
  })
}

// 上传图片
export function uploadFile(data) {    
  return request({
    url: "/OA/Files/Upload",
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
      "Access-Control-Allow-Origin": "*"
    }
  })
}

// 赛事报名渠道
export function ApiApplycompetitionchannel(data) {
  return request({
    url: "api/competitions/applycompetitionchannel",
    method: "POST",
    data
  })
}
